<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">group</span>
      <h2>Rôles et permissions</h2>
    </div>

    <p class="section-intro">
      Chaque utilisateur se voit attribuer un rôle qui détermine les modules auxquels il a accès.
      L'administrateur attribue les rôles lors de la création des comptes.
    </p>

    <h3 class="sub-title">Les 7 rôles du système</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Rôle</th><th>Modules accessibles</th><th>Description</th></tr>
        </thead>
        <tbody>
          <tr><td><span class="role-badge role-admin">Administrateur</span></td><td>Tous les modules</td><td>Accès total. Gère les utilisateurs, la configuration et supervise tout.</td></tr>
          <tr><td><span class="role-badge role-finance">Resp. financier</span></td><td>Comptabilité, Caisse, Stats, Clients, Commandes</td><td>Supervise les flux financiers et génère les rapports.</td></tr>
          <tr><td><span class="role-badge role-operations">Resp. opérations</span></td><td>Approvisionnement, Stocks, Inventaire, Retour, Pertes</td><td>Gère la chaîne logistique.</td></tr>
          <tr><td><span class="role-badge role-caisse">Caisse</span></td><td>Caisse, Commandes, Clients</td><td>Encaisse les paiements clients.</td></tr>
          <tr><td><span class="role-badge role-magasinier">Magasinier</span></td><td>Stocks (son magasin), Retour, Inventaire</td><td>Gère le stock physique de son magasin.</td></tr>
          <tr><td><span class="role-badge role-controleur">Contrôleur</span></td><td>Inventaire, Pertes</td><td>Effectue les inventaires de contrôle.</td></tr>
          <tr><td><span class="role-badge role-accueil">Accueil</span></td><td>Clients, Commandes</td><td>Accueille les clients et saisit les bons de commande.</td></tr>
        </tbody>
      </table>
    </div>

    <h3 class="sub-title">Attribuer un rôle à un utilisateur</h3>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p><strong>Ouvrir Paramétrage</strong> — Cliquez sur l'icône engrenage dans le menu latéral gauche.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p><strong>Onglet « Utilisateurs »</strong> — Cliquez sur l'onglet Utilisateurs en haut de la page.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p><strong>Cliquer sur <span class="btn-ref">Ajouter</span></strong> — Le formulaire utilisateur s'ouvre. Sélectionnez le rôle dans le champ <em>« Type d'utilisateur »</em>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p><strong>Cliquer sur <span class="btn-ref">Soumettre</span></strong> — Le compte est créé avec le rôle choisi.</p>
      </div>
    </div>

    <div class="info-card warning">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#ba4f4f">warning</span>
        Sécurité
      </div>
      <p>
        Seul l'Administrateur peut créer, modifier ou supprimer des comptes. Ne communiquez jamais votre mot de passe.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocRoles" };
</script>
